import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import TierBadge from '@wix/da-ds/pkg/Badges/TierBadge';
import VideoIcon from '@wix/da-ds/pkg/Icons/24x24/AddVideo';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import { useDeviationViewContext } from '../../../../Context';
import { getDeviationType, isDeviationPixelArt, isFileLargerThanSize, scaleToSize, getPrimaryTier, } from '../../../_helpers';
import { DeviationTypes } from '../../../../types/deviation';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';
import MediaService from '../../../../utils/DeviationMediaService';
import SubscribeButton from '../../../../Button/SubscribeButton';
import ImageContent from '../../Image/ImageContent';
import ContentShadow from '../ContentShadow';
import s from './SubPaywall.scss';
var SubPaywall = function (_a) {
    var _b, _c, _d, _e, _f;
    var width = _a.width, height = _a.height, deviation = _a.deviation, _g = _a.showImage, showImage = _g === void 0 ? false : _g, _h = _a.isStatusArtStage, isStatusArtStage = _h === void 0 ? false : _h, className = _a.className;
    var t = useTranslation().t;
    var isFullscreen = useDeviationViewContext().isFullscreen;
    var tier = getPrimaryTier(deviation);
    var isSubscribedButBlocked = useSubscriptionTier(deviation).isSubscribedButBlocked;
    var zoomedFile = MediaService.getLargestFullview(deviation);
    var isHuge = !!zoomedFile && isFileLargerThanSize(zoomedFile, width, height);
    var file = isHuge
        ? MediaService.getFullviewForSize(deviation, width, height)
        : zoomedFile;
    if (!file || !tier) {
        return null;
    }
    var size = scaleToSize(file, { width: width, height: height });
    var isPixel = isDeviationPixelArt(deviation);
    var isFilm = getDeviationType(deviation) === DeviationTypes.FILM;
    var authorName = (_b = deviation === null || deviation === void 0 ? void 0 : deviation.author) === null || _b === void 0 ? void 0 : _b.username;
    var primaryTierUrl = Url.deviationLink(tier.deviationId, authorName);
    return (React.createElement("div", { className: classNames(s['root'], !showImage && s['no-image'], isStatusArtStage && s['status'], isFullscreen && s['fullscreen'], className), style: { width: width, height: height } },
        showImage && (React.createElement(ContentShadow, { content: file, containerSize: { width: size === null || size === void 0 ? void 0 : size.width, height: size === null || size === void 0 ? void 0 : size.height }, useSmallStage: true, className: s['overlay'] },
            React.createElement("div", null,
                React.createElement(ImageContent, { key: file.src, width: size === null || size === void 0 ? void 0 : size.width, height: size === null || size === void 0 ? void 0 : size.height, file: file, alt: (_c = deviation.title) !== null && _c !== void 0 ? _c : '', isPixel: isPixel, canZoom: false, onZoom: function () { } })),
            isFilm && React.createElement(VideoIcon, { className: s['video-icon'] }))),
        React.createElement("div", { className: s['centered'], style: size },
            React.createElement(TierBadge, { size: 40, isLocked: true, className: s['icon'] }),
            React.createElement("div", { className: s['title'] }, t(isSubscribedButBlocked
                ? 'deviationview.subpaywall.title.subscribedButBlocked'
                : 'deviationview.subpaywall.title')),
            React.createElement("div", { className: s['main'] }, t(isSubscribedButBlocked
                ? 'deviationview.subpaywall.body.subscribedButBlocked'
                : 'deviationview.subpaywall.body', {
                username: (_d = deviation === null || deviation === void 0 ? void 0 : deviation.author) === null || _d === void 0 ? void 0 : _d.username,
                price: (_e = tier.tier) === null || _e === void 0 ? void 0 : _e.dollarPrice,
            })),
            isSubscribedButBlocked ? (React.createElement(BrandedButton, { size: "medium", variant: "brand-green", href: primaryTierUrl }, t('deviationview.subpaywall.cta.subscribeWithUsername', {
                username: (_f = deviation === null || deviation === void 0 ? void 0 : deviation.author) === null || _f === void 0 ? void 0 : _f.username,
            }))) : (React.createElement(SubscribeButton, { tier: tier })))));
};
SubPaywall.displayName = 'SubPaywall';
export default SubPaywall;
//# sourceMappingURL=SubPaywall.js.map